<script>
import { mapActions, mapGetters } from "vuex";

import { event } from "vue-analytics";

import addressMixin from "@/mixins/addressMixin";

import EditAddress from "@/components/_Shared/Addresses/EditAddress";

export default {
  mixins: [addressMixin],

  components: {
    EditAddress
  },

  props: {
    address: {
      type: Object,
      required: true
    },

    selected: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      editing: false
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["setAddress"]),

    selectAddress(addressId) {
      try {
        event(
          "cliente",
          "click",
          `fluxo:teste:cliente_${this.firstOrderUser ? "novo" : "recorrente"}:${
            this.address.district.city.code
          }`
        );
      } catch (e) {}

      if (!this.selected) {
        this.setAddress({ addressId, queryParams: this.$route.query });
      }

      this.$emit("addressSelected");
    }
  },

  computed: {
    ...mapGetters("user", ["firstOrderUser"]),
    cityClosed: function() {
      return this.isCityClosed(this.address.district.city);
    }
  }
};
</script>

<template>
  <div
    class="address"
    :class="{
      'address-disabled': cityClosed,
      'address-selected': selected
    }"
  >
    <div class="address-content" @click="!cityClosed && selectAddress(address.id)">
      <span class="address-label">
        {{ address | name }}
      </span>

      <span class="address-street">
        {{ address | streetAddress }}
      </span>

      <span class="address-city">
        {{ address | residencyLocation }}
      </span>

      <p v-if="cityClosed" class="alert">
        Não estamos operando mais nessa cidade!
      </p>
    </div>

    <img
      v-if="!cityClosed"
      src="/static/icon-edit.svg"
      @click="editing = true"
    />

    <EditAddress
      v-if="editing"
      :address="address"
      @close="editing = false"
    />
  </div>
</template>

<style scoped>
.address {
  width: calc(100% - 24px - 24px);
  padding: 12px;
  margin: 4px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border: solid 1px #e2e2e2;
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
  user-select: none;
  cursor: pointer;
}

.address-disabled {
  opacity: 0.5;
  background: #e2e2e2;
}

.address-selected {
  width: calc(100% - 28px);
  border: solid 2px #603285;
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
}

.address-content {
  width: calc(100% - 36px);
  display: flex;
  flex-direction: column;
}

.address-label {
  font-size: 15px;
  color: #603285;
  font-weight: 500;
  margin-bottom: 4px;
}

.address-street {
  font-size: 13px;
  color: #666;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address-city {
  font-size: 13px;
  color: #666;
  font-weight: 400;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alert {
  margin-bottom: 0;
  color: #af006b;
  font-size: 12px;
  text-align: center;
  opacity: 1;
}

img {
  width: 20px;
  height: 20px;
  opacity: 0.75;
  padding-left: 16px;
  cursor: pointer;
}

img:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Address.vue